import { Box, Text } from '@factorialco/deprecated-design-system'
import { ComplaintsDataCollectionItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ActivityFeed from 'modules/complaints/pages/ComplaintDetailPage/SideContent/ActivityFeed'

interface Props {
  data: ComplaintsDataCollectionItemFragment
}

export const ComplaintSideContent: React.FC<Props> = ({ data }) => {
  return (
    <Box gap="s24">
      <Text.Normal size="200" color="grey700" weight="medium" caps>
        {i18n.t('complaints.activity.activity_feedtitle')}
      </Text.Normal>
      <ActivityFeed complaint={data} />
    </Box>
  )
}
